import React from "react";
import CollectionSearchDropdown from "./CollectionSearchDropdown";

function TrackSearchDropdown({ onSelect, ...props }) {
  return (
    <CollectionSearchDropdown
      types="track"
      onSelect={(res) => onSelect(res.item.id)}
      {...props}
    />
  );
}

export default TrackSearchDropdown;
